module.exports = __webpack_public_path__ + "img/img_throw_6@3x_v2.775eca5f.png";